/** @mui/material imports */
/** @mui/icons-material imports */
/** React imports */
import { Context, createContext, useState } from 'react';
/** Goldspot imports */
import {
  RecommendationRequest,
  Recommendations,
} from '../TypeScript/interfaces';

export interface WizardContextProviderProps {
  children: JSX.Element;
}

export interface WizardContextType {
  wizardInput?: RecommendationRequest;
  setWizardInput: (wizardInput: RecommendationRequest) => void;
  wizardOutput?: Recommendations;
  setWizardOutput: (wizardOutput: Recommendations) => void;
}

export const WizardContext: Context<WizardContextType> = createContext({
  setWizardInput: (wizardInput: RecommendationRequest): void => {},
  setWizardOutput: (wizardOutput: Recommendations): void => {},
});

export const WizardContextProvider: React.FC<WizardContextProviderProps> = (
  props: WizardContextProviderProps
) => {
  const [wizardInput, setWizardInput] = useState<RecommendationRequest>();
  const [wizardOutput, setWizardOutput] = useState<Recommendations>();
  return (
    <>
      <WizardContext.Provider
        value={{
          wizardInput,
          setWizardInput,
          wizardOutput,
          setWizardOutput,
        }}
      >
        {props.children}
      </WizardContext.Provider>
    </>
  );
};
